module.exports = __webpack_public_path__ + "img/ic_charge_empty.5bae8b2c.png";